const STATUS_TRANSLATION_KEYS = {
  open: 'TICKETS.STATUS.OPEN',
  in_progress: 'TICKETS.STATUS.IN_PROGRESS',
  pending: 'TICKETS.STATUS.PENDING',
  resolved: 'TICKETS.STATUS.RESOLVED',
  canceled: 'TICKETS.STATUS.CANCELED',
  closed: 'TICKETS.STATUS.CLOSED',
  spam: 'TICKETS.STATUS.SPAM',
};

export const ticketStatusLabel = (status, translate) => {
  const translationKey = STATUS_TRANSLATION_KEYS[status];
  return translationKey ? translate(translationKey) : status;
};
